<template>
  <base-switch
    v-model="formData"
    :label="formData ? 'Sim' : 'Não'" />
</template>

<script>

export default {
  name: "BooleanAvaliationItemStrategy",
  props: {
    avaliationItem: {
      type: Object,
      required: true,
      default: () => ({
        min_date: null,
        max_date: null,
      }),
    },
    value: {
      type: Object,
    },
  },
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    config() {
      return this.avaliationItem.config || {};
    },
  },
}
</script>
